import { useIntl } from 'react-intl';
import { Tooltip } from '@ets/design-system';
import cx from 'classnames';

import { navigateToMyFiles } from 'router/navigation';
import { useIEnvision } from '_common/hooks';

import { Logo } from '_common/components';

import styles from './Title.module.scss';

const LOGO_COLORS = {
  dopdf: 'red',
  presentation: 'orange',
  document: 'blue',
} as const;

type SuiteLogoProps = {
  object: doDOC.Document | doDOC.PDF | doDOC.Presentation;
};

const SuiteLogo = ({ object }: SuiteLogoProps) => {
  const intl = useIntl();
  const isIEnvision = useIEnvision();

  const handleLogoClick = () => {
    if (!isIEnvision) {
      navigateToMyFiles();
    }
  };

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'GO_BACK_EXPLORER' })}
      placement="right"
      visible={!isIEnvision}
      testId="go-to"
    >
      <span
        onClick={handleLogoClick}
        className={cx({ [styles.clickable]: !isIEnvision })}
        data-testid="logo"
        style={{ marginRight: '1rem' }}
      >
        <Logo color={LOGO_COLORS[object.type]} testId="title-logo" size="medium" />
      </span>
    </Tooltip>
  );
};

export default SuiteLogo;
